
import PayResult from '@/components/PayResult'
const PayFail = () => {
    const element = (<PayResult resultType={0} />);
    return element
}
export default PayFail